<template>
	<div class="container-fluid">
		<navigation-admin></navigation-admin>
		<div class="row row-fluid wrapper-flexbox">
			<sidebar-admin></sidebar-admin>
			<section class="col-sm-10 admin-background-shadow overflow">
				<div class="row">
					<div class="col-sm-5 padding-title">
						<p class="admin-header">Projects Contract</p>
					</div>
					<div class="col-sm-offset-5 col-sm-2">
						<a v-link="{ path: '/admin/projects-new' }"type="button" class="btn btn-black btn-lg">Nuevo proyecto</a>
					</div>
				</div>
				<div class="row row-fluid absolut">
					<div class="col-sm-12 table-responsive">
						<table-admin-projects :list="render_projects" :remove="remove"></table-admin-projects>
						<div v-if="!render_projects.length" class="text-center empty">No hay proyectos en la plataforma.</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<style>
	.padding-title{
		padding: 20px;
	}
</style>

<script>
import navigationAdmin from '../../components/Admin/Admin-navigation.vue';
import sidebarAdmin from '../../components/Admin/Admin-sidebar.vue';
import tableAdminProjects from '../../components/Admin/Admin-projects-table.vue';
import { confirm } from '../../scripts/confirm';
import { removeContractProject } from '../../store/actions';

export default {
	// ----- COMPONETNS -----

  components: {
    navigationAdmin,
    sidebarAdmin,
    tableAdminProjects,
  },

  // ----- VUEX -----

  vuex: {
  	getters: {
  		projects: state => state.projects,
      user: state => state.current_user
  	},
    actions: {
      removeContractProject
    }
  },

  // ----- METHODS -----

  methods: {
  	remove(project) {
      var vm = this;

      confirm({
        title: 'Eliminar Proyecto',
        content: 'Seguro que quieres eliminar ' + project.title,
        
        confirm: function () {
          vm.removeContractProject(vm.user, project);
        },

        cancel: function () {
          // :(
        }
      })
  	}
  },

  // ----- RENDER -----

  computed: {
  	render_projects() {
  		return this.projects;
  	}
  }
}
</script>


// WEBPACK FOOTER //
// Admin-projects.vue?6f2777cb